import template from './template.html';
import blockBase from "../../mixins/blockBase";
import Carousel from "../carousel";

export default {
    name: 'case',
    template: template,
    props: {
        page: Object,
    },
    components: {
        Carousel,
    },
    mixins: [
        blockBase,
    ],
};